
var originalEnsureChunk = __webpack_require__.e;
var originalLoadScript = __webpack_require__.l;
var pendingChunkLoads = Object.create(null);
var timeoutChunkRequests = Object.create(null), timeoutRequestSequence = 0;
if (typeof originalLoadScript === 'function') {
  __webpack_require__.l = function(url, done, key, chunkId) {
    var request = timeoutChunkRequests[chunkId];
    var args = Array.prototype.slice.call(arguments);
    if (request && typeof url === 'string') {
      // Next encodes the filename returned by .u with encodeURIPath. A query
      // added there becomes a literal %3F path and always 404s. Add it only
      // after that encoding, at the original script loader's URL boundary.
      var fragmentAt = url.indexOf('#');
      var fragment = fragmentAt < 0 ? '' : url.slice(fragmentAt);
      var base = fragmentAt < 0 ? url : url.slice(0, fragmentAt);
      args[0] = base + (base.indexOf('?') < 0 ? '?' : '&') + '__dobi_chunk_retry=' + request + fragment;
    }
    return originalLoadScript.apply(this, args);
  };
}
__webpack_require__.e = function(chunkId) {
  if (pendingChunkLoads[chunkId]) return pendingChunkLoads[chunkId];
  var context = this, args = arguments;
  var retries = 0, sawTimeout = false, startedAt = Date.now();
  function outcome(state, error) {
    try {
    var record = { state: state, chunkId: String(chunkId), attempts: retries + 1,
      elapsedMs: Date.now() - startedAt, sawTimeout: sawTimeout,
      errorType: error && typeof error.type === 'string' ? error.type : null };
    if (typeof navigator !== 'undefined' && typeof navigator.onLine === 'boolean') record.online = navigator.onLine;
    // Numeric transport evidence only. A server-side 200 does not prove that
    // this browser received a complete script. Never copy resource names/URLs.
    if (error && typeof error.request === 'string' && typeof performance !== 'undefined'
        && typeof performance.getEntriesByName === 'function') {
      var entries = performance.getEntriesByName(error.request, 'resource');
      var timing = entries.length ? entries[entries.length - 1] : null;
      if (timing && timing.initiatorType === 'script') {
        var evidence = {};
        ['duration', 'transferSize', 'encodedBodySize', 'decodedBodySize', 'responseStatus'].forEach(function(key) {
          var value = timing[key];
          if (typeof value === 'number' && isFinite(value) && value >= 0 && value <= 1000000000) evidence[key] = value;
        });
        record.resourceTiming = evidence;
      }
    }
    if (error && typeof error === 'object') error.dobiChunkRecovery = record;
    if (typeof self !== 'undefined') {
      var history = Array.isArray(self.__dobiChunkRecovery) ? self.__dobiChunkRecovery : (self.__dobiChunkRecovery = []);
      history.push(record);
      if (history.length > 16) history.splice(0, history.length - 16);
    }
    } catch (_) { /* Diagnostics must never replace the original loader result. */ }
  }
  function load() {
    return originalEnsureChunk.apply(context, args).catch(function(error) {
      var transportFailure = error && error.name === 'ChunkLoadError';
      if (error && error.type === 'timeout') sawTimeout = true;
      // Preserve webpack's full per-request slow-network window. Once that
      // window has expired, allow at most one additional original-loader try.
      if (!transportFailure || retries >= (sawTimeout ? 1 : 2)) {
        if (transportFailure) outcome('exhausted', error);
        throw error;
      }
      // Even a completed 200 response can contain a stale/missing chunk. Every
      // transport retry must escape that URL's browser/CDN cache entry.
      timeoutChunkRequests[chunkId] = Date.now().toString(36) + '-' + (++timeoutRequestSequence);
      var delay = retries++ === 0 ? 250 : 750;
      return new Promise(function(resolve) { setTimeout(resolve, delay); }).then(load);
    });
  }
  var pending = load().then(function(value) {
    if (retries) outcome('recovered');
    return value;
  });
  pendingChunkLoads[chunkId] = pending;
  function settled() {
    if (pendingChunkLoads[chunkId] === pending) {
      delete pendingChunkLoads[chunkId];
      delete timeoutChunkRequests[chunkId];
    }
  }
  pending.then(settled, settled);
  return pending;
};